// src/constants/dataTypes.js

export const fwdDataTypes = {
  DMReadout: 'Meter readout' ,
  DMScan: 'Meter scan',
  QnodeReadout: 'Network readout',
  QnodeScan: 'Network scan',
  // CustomerReport: 'Report'
}



// export const fwdDataTypes = [
//   { value: 'DMReadout', label: 'Meter readout' },
//   { value: 'DMScan', label: 'Meter scan' },
//   { value: 'QnodeReadout', label: 'Network readout' },
//   { value: 'QnodeScan', label: 'Network scan' },
//   { value: 'CustomerReport', label: 'Report' }
// ];
